document.addEventListener("DOMContentLoaded", function() {
  function updatePrice(currentVariant, container, plan, salePrice) {
    if (plan) {
      container.querySelectorAll(".js-sale-plan-price")?.forEach((salePriceEl, i) => {
        salePriceEl.innerHTML = plan.price;
        salePriceEl.closest('.subscr-box__prices-container')?.classList.add('is-on-sale');
      })
    }
    if (salePrice) {
      container.querySelectorAll(".js-sale-price")?.forEach((salePriceEl, i) => {
        salePriceEl.innerHTML = currentVariant.dataset.salePrice;
        salePriceEl.closest('.subscr-box__prices-container')?.classList.add('is-on-sale');
      })
    }

    container.querySelectorAll(".js-product-price")?.forEach((productPrice, i) => {
      if(currentVariant.dataset.comparePrice > currentVariant.dataset.price) {
        productPrice.innerHTML = currentVariant.dataset.comparePrice;
        productPrice.closest('.subscr-box__prices-container')?.classList.add('is-on-sale');
      }
      else {
        productPrice.innerHTML = currentVariant.dataset.price;
      }
    })

    container.querySelectorAll(".js-sale-price")?.forEach((salePrice, i) => {
      if(currentVariant.dataset.comparePrice > currentVariant.dataset.price) {
        salePrice.innerHTML = currentVariant.dataset.salePrice;
      }
    })


  }

  function updateAddToCart(currentVariant, container, plan, salePrice) {

    document.querySelectorAll('.js-atc-btn')?.forEach((btn) => {
      if (currentVariant.dataset.available === 'true') {
        btn.removeAttribute('disabled');
      }
      else {
        btn.setAttribute('disabled', true);
      }
    })
    document.querySelectorAll(".js-atc-prices")?.forEach((prices) => {
      prices.querySelectorAll(".js-product-price")?.forEach((productPrice, i) => {
        if(currentVariant.dataset.comparePrice > currentVariant.dataset.price) {
          productPrice.innerHTML = currentVariant.dataset.comparePrice;
          productPrice.classList.add('is-on-sale');
        }
        else {
          productPrice.innerHTML = currentVariant.dataset.price;

          prices.querySelectorAll(".js-sale-price")?.forEach((salePriceEl, i) => {
            salePriceEl.innerHTML = '';
          })
        }

      })
      if (plan) {
        prices.querySelectorAll(".js-sale-price")?.forEach((salePriceEl, i) => {
          salePriceEl.innerHTML = plan.price;
        })
      }
      else if (salePrice) {
        prices.querySelectorAll(".js-sale-price")?.forEach((salePriceEl, i) => {
          productPrice.innerHTML = currentVariant.dataset.comparePrice;
        })
      }
      if (plan || salePrice) {
        prices.classList.add('is-on-sale');
      }
      else {
        prices.classList.remove('is-on-sale');
      }
    })
  }
  function checkOptionsMatch(currentOptions, variantDataset) {
    for (const key in currentOptions) {
      if (
        variantDataset.hasOwnProperty(key) &&
        currentOptions[key] !== variantDataset[key]
      ) {
        return false;
      }
    }
    return true;
  }
  function changeVariant(currentVariant, container) {
    console.log("currentVariant", currentVariant);
    if (currentVariant) {
      var variantSelector = container.querySelector(".js-all-variants");
      variantSelector.value = currentVariant.value;
      const planId = container.querySelector('.js-plan-selector')?.value;
      const plans = JSON.parse(currentVariant.dataset.recharge);
      console.log(plans, planId);
      const plan = container.querySelector(".js-subscr-box.active")?.dataset.subscr === 'true' ? plans.find(plan => plan.id === planId) : false;
      const salePrice = currentVariant.dataset.salePrice !== currentVariant.dataset.price ? currentVariant.dataset.salePrice : 0;
      updatePrice(currentVariant, container, plan, salePrice);
      updateAddToCart(currentVariant, container, plan, salePrice);
    }
  }

  document.querySelectorAll(".js-product-option")?.forEach(function (btn, i) {
    var container = btn.closest(".js-product-form");
    btn.addEventListener("click", function (e) {
      btn
        .closest(".js-options-group")
        .querySelectorAll(".js-product-option")
        .forEach(function (btn) {
          btn.classList.remove("active");
        });
      btn.classList.add("active");

      var currentVariant;
      var currentOptions = {};
      container
        .querySelectorAll(".js-product-option.active")
        .forEach(function (option) {
          const key = `option-${option.dataset.index}`
          currentOptions[key] = option.value;
        });
      console.log(currentOptions);
      container
        .querySelectorAll(".js-all-variants option")
        .forEach(function (variant) {
          if (checkOptionsMatch(currentOptions, variant.dataset)) {
            currentVariant = variant;
          }
        });
      console.log("currentVariant", currentVariant);

      if (currentVariant) {
        changeVariant(currentVariant, container);
      }
    });
  });
  document.querySelector('.js-plan-selector')?.addEventListener('change', function () {
    const container = this.closest('.js-product-form');
    changeVariant(getCurrentVariant(container), container);
  })
  document.querySelectorAll('.js-subscr-box')?.forEach(function (box) {
    box.addEventListener('click', function () {
      const container = this.closest('.js-product-form');
      container.querySelectorAll('.js-subscr-box').forEach(function (box) {
        box.classList.remove('active')
      })
      box.classList.add('active');
      changeVariant(getCurrentVariant(container), container);
    })
  })
  function getCurrentVariant(container) {
    var variantSelector = container.querySelector(".js-all-variants");
    var currentVariant = variantSelector.options[variantSelector.selectedIndex];
    return currentVariant;
  }
  document.querySelectorAll(".js-product-form")?.forEach(function (container) {
    changeVariant(getCurrentVariant(container), container);
  });
});